import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="animate"
export default class extends Controller {
  static classes = ["hidden", "visible"]
  static values = {
    delay: { type: Number, default: 0 },
    duration: { type: String, default: "0.6s" },
    easing: { type: String, default: "cubic-bezier(0.25, 0.46, 0.45, 0.94)" }
  }

  connect() {
    this.setupObserver()
    this.setupInitialState()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupInitialState() {
    // Set initial state - hidden and translated down
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(50px)"
    this.element.style.transition = `opacity ${this.durationValue} ${this.easingValue}, transform ${this.durationValue} ${this.easingValue}`
  }

  setupObserver() {
    const options = {
      root: null,
      rootMargin: "0px 0px -100px 0px", // Trigger when element is 100px from bottom of viewport
      threshold: 0.1
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateIn()
        }
      })
    }, options)

    this.observer.observe(this.element)
  }

  animateIn() {
    // Add delay if specified
    setTimeout(() => {
      this.element.style.opacity = "1"
      this.element.style.transform = "translateY(0)"

      // Add visible class if defined
      if (this.hasVisibleClass) {
        this.element.classList.add(this.visibleClass)
      }

      // Remove hidden class if defined
      if (this.hasHiddenClass) {
        this.element.classList.remove(this.hiddenClass)
      }
    }, this.delayValue)

    // Disconnect observer after animation to prevent re-triggering
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
